import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type MessageState = 'NEW' | 'OPEN' | 'SENT' | 'READ' | 'CONFIRMED';

export interface Message {
  id: string;
  orderNr: string;
  title: string;
  messageState: MessageState;
  dateCreated: string;
  messageSent: string | null;
  messageRead: string | null;
  body: string | null;
  outgoing: boolean;
  /** True for SYSTEM messages (order-confirmation/order-change) as opposed to a staff-authored STAFF2CUST
   * reply - lets the message list label the sender "System" vs "Team". */
  system: boolean;
  /** Id of the message this one answers, if any. */
  threadId: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private readonly apiUrl = `${environment.apiUrl}/messages/mine`;

  constructor(private readonly http: HttpClient) {
  }

  listMine(): Observable<Message[]> {
    return this.http.get<Message[]>(this.apiUrl);
  }

  /** Ids of the caller's own unread incoming messages - see NewMessageAlertService. */
  unreadIds(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/unread-ids`);
  }

  markRead(id: string): Observable<Message> {
    return this.http.patch<Message>(`${this.apiUrl}/${id}/read`, {});
  }

  /** threadId: the staff message this one answers, if it is an answer. */
  sendToStaff(orderNr: string, body: string, threadId: string | null = null): Observable<Message> {
    return this.http.post<Message>(this.apiUrl, { orderNr, body, threadId });
  }
}
